import React, { useState } from 'react';
import { FaUser, FaTimes } from 'react-icons/fa';

const Navbar = ({ user, onLogout, onLogin, onRegister, showLogin, setShowLogin }) => {
  const [isRegister, setIsRegister] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isRegister) {
      onRegister(name, email, password);
    } else {
      onLogin(email, password);
    }
    setName('');
    setEmail('');
    setPassword('');
  };

  return (
    <>
      <nav className="navbar">
        <div className="nav-container">
          <div className="logo">
            <span className="logo-icon">📊</span>
            <span className="logo-text">Taxave</span>
          </div>
          <ul className="nav-links">
            <li><a href="#services">Services</a></li>
            <li><a href="#contact">Contact</a></li>
            <li>
              {user ? (
                <div className="user-menu">
                  <span className="user-name"><FaUser /> {user.name}</span>
                  <button onClick={onLogout} className="btn btn-logout">Logout</button>
                </div>
              ) : (
                <button onClick={() => setShowLogin(true)} className="btn btn-login">
                  Login / Register
                </button>
              )}
            </li>
          </ul>
        </div>
      </nav>

      {showLogin && !user && (
        <div className="modal-overlay" onClick={() => setShowLogin(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowLogin(false)}>
              <FaTimes />
            </button>
            <h2>{isRegister ? 'Create Account' : 'Welcome Back'}</h2>
            <form onSubmit={handleSubmit} className="auth-form">
              {isRegister && (
                <input
                  type="text"
                  placeholder="Full Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              )}
              <input
                type="email"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
              />
              <button type="submit" className="btn btn-primary btn-full">
                {isRegister ? 'Register' : 'Login'}
              </button>
            </form>
            <p className="auth-toggle">
              {isRegister ? 'Already have an account? ' : 'Don\'t have an account? '}
              <button 
                className="btn-link" 
                onClick={() => setIsRegister(!isRegister)}
              >
                {isRegister ? 'Login' : 'Register'}
              </button>
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;